// extracted by mini-css-extract-plugin
module.exports = {"invite":"index_invite_3s6Qk","rules":"index_rules_2k4wd","link":"index_link_cTkfQ"};